export const requestQuotationConstants = {
    LOADING: 'RESQUEST_QUOTATION_LOADING',
    GET_ALL_SUCCESS: 'RESQUEST_QUOTATION_GET_ALL_SUCCESS',
    GET_ALL_FAILURE: 'RESQUEST_QUOTATION_GET_ALL_FAILURE'
};
